import {useWindowInnerHeight} from '../../../../../../common/shared/hooks/useWindowInnerHeight';
import useTypedSelector from '../../../../../../common/useTypedSelector';
import {ViewerEndContainer} from './ViewerEndContainer';

export function TalkViewerEndContainer({
  seriesId,
  productId,
  onClickStar,
}: {
  seriesId: number;
  productId: number;
  onClickStar: (parameters?: {fromSavedCommand?: boolean}) => void;
}) {
  const {isViewerEndExposed, viewerMenuHeight} = useTypedSelector(state => {
    return {
      isViewerEndExposed: state.viewerEnd.isExposed,
      viewerMenuHeight: state.talkViewer.settings.viewerMenuHeight,
    };
  });

  const windowInnerHeight = useWindowInnerHeight();

  return !isViewerEndExposed ? null : (
    <div
      className="pr-safe pl-safe"
      style={{
        paddingTop: viewerMenuHeight.top + VIEWER_END_EXTRA_MARGIN,
        paddingBottom: viewerMenuHeight.bottom + VIEWER_END_EXTRA_MARGIN,
        minHeight: windowInnerHeight,
      }}
    >
      <ViewerEndContainer
        seriesId={seriesId}
        productId={productId}
        onClickStar={onClickStar}
      />
    </div>
  );
}

const VIEWER_END_EXTRA_MARGIN = 10;
